exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/navbar/navbar.component.css
// module id = ../../../../../src/app/navbar/navbar.component.css
// module chunks = main